jQuery('.megamenu .first-sub').each(function() {
	var megamenuFirstChildCount = jQuery(this).children('li').length;
	jQuery(this).css({
		width: 220*megamenuFirstChildCount+'px',
	});
});

